module.exports = __webpack_public_path__ + "media/images/welcome/feature2-1-92044949c5e5023b9dea8bff7f66e026.png";